export default "__VITE_PUBLIC_ASSET__84a5285f__"